import {
  Table,
  Pagination,
  Switch,
  Modal,
  Select,
  Input,
  message,
  Popover,
} from "antd";
import React, { useState, useEffect, useRef } from "react";
import "./SrTable.css";
import EditIcon from "../../../images/edit-icon.png";
import { CopyOutlined, CloseOutlined, CheckOutlined } from "@ant-design/icons";
import Info from "../../../images/info.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getSrInitialList,
  editSrStyleList,
  duplicateSrStyleList,
  getSrLogs,
  massSrSearchFilter,
  resetSrMassFilter
} from "../../../Redux/actions/Sr/Sr";
import { Loader } from "../../../UIComponents/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";

const TOTAL_PER_PAGE = 100;

export const normalizeGrossValueForSave = (value) => {
  if (value === null || value === undefined) return "";

  const trimmedValue = `${value}`.trim();
  if (!trimmedValue) return "";

  const sanitizedValue = trimmedValue
    .replace(/[^0-9.]/g, "")
    .replace(/(\..*)\./g, "$1");

  if (!sanitizedValue) return "";

  const [wholePart = "", decimalPart = ""] = sanitizedValue.split(".");
  const limitedWholePart = `${wholePart || "0"}`.slice(0, 4);

  if (!sanitizedValue.includes(".")) {
    return `${limitedWholePart}.00`;
  }

  if (decimalPart === "") {
    return `${limitedWholePart}.00`;
  }

  return `${limitedWholePart}.${decimalPart}`;
};

const SrTable = ({
  selectedRows,
  brand,
  onSelectionChange,
  searchInput,
  setSearchInput,
  vendorFilter,
  setVendorFilter,
  colorFilter,
  setColorFilter,
  sizeFilter,
  setSizeFilter,
  pageCount,
  current,
  setCurrent,
  setPageCount,
  totalPerPage,
  chunkSize,
  containerRef,
  seasonFilter
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [editingRowKey, setEditingRowKey] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isLogsModalOpen, setisLogsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [popupOpen, setIsPopupOpen] = useState(false);
  const [popupMessage, isPopupMessage] = useState("")
  const queryParams = new URLSearchParams(location.search);
  const isChangingPageSizeRef = useRef(false);
  const [visibleCount, setVisibleCount] = useState(chunkSize);
  const [isChunkLoading, setIsChunkLoading] = useState(false);
  const [openDropdownKey, setOpenDropdownKey] = useState(null);
  const [productLineDropdownOpen, setProductLineDropdownOpen] = useState(false);
  const [originalProductLine, setOriginalProductLine] = useState({});
  const grossInputRef = useRef(null);
  const productLineRef = useRef(null);
  const [originalGrossWholesaleValue, setOriginalGrossWholesaleValue] = useState({});
  const [hasEditedRow, setHasEditedRow] = useState(false);
  useEffect(() => {
    setVisibleCount(chunkSize);

    // ✅ Reset scroll ONLY when page changes (not chunk load)
    const scrollEl = containerRef?.containerRef?.containerRef?.current;

    if (scrollEl && current === 1) {
      scrollEl.scrollTop = 0;
    }
  }, [current]);

  const updateQueryParams = (page, pageSize) => {
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    params.set("pageSize", pageSize);
    navigate({ search: params.toString() }, { replace: true });
  };

  const srList = useSelector((state) => state?.Sr?.getSrDataList);
  const loading = useSelector((state) => state?.Sr?.loading);
  const srLogs = useSelector((state) => state?.Sr?.srLogsData);
  const SrLogsLoading = useSelector((state) => state?.Sr?.srLogsLoading);
  const userNameMicrosoft = useSelector(
    (state) => state?.Profile?.graphCompleteData?.displayName
  );
  const massFilterApiData = useSelector(
    (state) => state?.Sr?.massSrSearchFilterResult
  );

  // const seasonFilter = massFilterApiData?.seasonfilter || srList?.seasonfilter || "";
  const srSeasonData = useSelector((state) => state?.Sr?.srSeasonSearch);
  // -------------------- HELPERuS --------------------
  const getDisabledStyle = (isDisabled) => ({
    opacity: isDisabled ? 0.5 : 1,
    pointerEvents: isDisabled ? "none" : "auto",
    cursor: isDisabled ? "not-allowed" : "pointer",
  });

  const intialSearch = () => {
    const hasFilters =
      searchInput ||
      vendorFilter ||
      colorFilter ||
      sizeFilter ||
      (seasonFilter && seasonFilter.length > 0);

    if (hasFilters && massFilterApiData?.results) {
      return massFilterApiData.results;
    }
    if (srSeasonData?.results?.length > 0) {
      return srSeasonData.results;
    }
    if (srList?.results?.length) {
      return srList.results;
    }
    return [];
  };

  // -------------------- DATA --------------------
  useEffect(() => {
    const sourceData = intialSearch();
    console.log("sourceDta", sourceData);
    const formattedData =
      sourceData?.map((item) => ({
        key: item?.id,
        style: item?.style,
        description: item?.description,
        vendor: item?.factory,
        size: item?.size,
        color: item?.color_code,
        productLine: item?.product_line,
        grossWholesalePrice: item?.gross_wholesale_price || "",
        status: item?.status,
        state: item?.state,
        season: item?.season,
        packagingStatus: item?.packaging_status,
        packingTypeIdentified: item?.packing_type_identified,
        packagingSizeVendorConfirmed: item?.packaging_size_vendor_confirmed,
        packagingGraphicsFinalized: item?.packaging_graphics_finalized,
      })) || [];

    setTableData(formattedData);
  }, [srList, massFilterApiData, srSeasonData]);

  // -------------------- SELECTION --------------------
  useEffect(() => {
    setSelectedRowKeys(selectedRows || []);
  }, [selectedRows]);

  const onSelectChange = (keys) => {
    const filteredKeys = tableData
      .filter(
        (row) => keys.includes(row.key) && row.state !== "Cancel"
      )
      .map((row) => row.key);

    setSelectedRowKeys(filteredKeys);
    onSelectionChange?.(filteredKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.state === "Cancel",
    }),
  };

  const handleDuplicate = async (record) => {
    try {
      const response = await dispatch(duplicateSrStyleList(userNameMicrosoft, record.key));
      const hasFilters =
        searchInput ||
        vendorFilter ||
        colorFilter ||
        sizeFilter ||
        (seasonFilter && seasonFilter.length > 0);
      if (hasFilters) {
        dispatch(
          massSrSearchFilter(
            searchInput,
            brand,
            colorFilter,
            sizeFilter,
            vendorFilter,
            0,
            seasonFilter,
            current,
            pageCount
          )
        );
      } else if (srSeasonData?.results?.length) {
        // 🔹 Season filter active (if separate API)
        dispatch(
          massSrSearchFilter(
            searchInput,
            brand,
            colorFilter,
            sizeFilter,
            vendorFilter,
            0,
            seasonFilter,
            current,
            pageCount
          )
        );
      } else {
        // 🔹 Default list
        dispatch(
          getSrInitialList(
            brand,
            "",
            "",
            0,
            "",
            "",
            current,
            pageCount
          )
        );
      }
      setIsPopupOpen(true);
      isPopupMessage("Line Item Duplicated Successfully")

    } catch (error) {
      console.error("Duplicate failed:", error);
    }
  };

  const handleStatusChange = async (checked, record) => {
    const newState = checked ? "Active" : "Cancel";

    setTableData((prev) =>
      prev.map((row) =>
        row.key === record.key ? { ...row, state: newState } : row
      )
    );

    await dispatch(
      editSrStyleList(
        userNameMicrosoft,
        record.key,
        "",
        newState,
        "",
      )
    );
  };

  const onLogsClick = (record) => {
    setSelectedRecord(record);

    if (
      record?.vendor &&
      record?.style &&
      record?.color &&
      record?.size
    ) {
      dispatch(
        getSrLogs(
          record.key,
          record.style,
          record.vendor,
          record.size,
          record.color
        )
      );
    }

    setisLogsModalOpen(true);
  };

  const sanitizeGrossValue = (value) => {
    if (value === null || value === undefined) return "";

    const sanitized = `${value}`.replace(/[^0-9.]/g, "");
    if (!sanitized) return "";

    const normalized = sanitized.replace(/(\..*)\./g, "$1");
    const [wholePart = "", decimalPart = ""] = normalized.split(".");
    const limitedWholePart = wholePart.slice(0, 4);

    if (normalized.includes(".")) {
      if (decimalPart === "") {
        return limitedWholePart ? `${limitedWholePart}.` : ".";
      }

      return `${limitedWholePart}.${decimalPart}`;
    }

    return limitedWholePart;
  };

  const validateMandatoryEditFields = (record) => {
    const currentRow = tableData.find((row) => row.key === record.key) || record;
    const productLineValue = `${currentRow.productLine ?? ""}`.trim();
    const rawGrossValue = `${currentRow.grossWholesalePrice ?? ""}`.trim();
    const grossValue = normalizeGrossValueForSave(rawGrossValue);

    if (!productLineValue) {
      message.error("Product line is required.");
      return false;
    }

    if (!grossValue) {
      message.error("Gross wholesale price is required.");
      return false;
    }

    if (!/^(?:\d{1,4})(?:\.\d+)?$/.test(grossValue)) {
      message.error("Gross wholesale price must be a valid decimal number.");
      return false;
    }

    return { productLineValue, grossValue };
  };

  const handleEditorBlur = (record) => {
    setTimeout(() => {
      const activeElement = document.activeElement;
      const isInsideProductLineEditor = activeElement?.closest(".sr-edit-productline-wrapper");
      const isInsideGrossEditor = activeElement?.closest(".sr-edit-gross-wrapper");

      if (isInsideProductLineEditor || isInsideGrossEditor) {
        return;
      }

      // If the row hasn't been edited, just close editor
      if (!hasEditedRow) {
        setEditingRowKey(null);
        setProductLineDropdownOpen(false);
        return;
      }

      // Validate current values. validateMandatoryEditFields shows toast errors when invalid.
      const validationResult = validateMandatoryEditFields(record);

      if (!validationResult) {
        // Keep the row editing and focus the first missing field so the input caret blinks.
        setEditingRowKey(record.key);

        const currentRow = tableData.find((row) => row.key === record.key) || record;
        const productLineValue = `${currentRow.productLine ?? ""}`.trim();
        const grossValue = `${currentRow.grossWholesalePrice ?? ""}`.trim();

        if (!productLineValue) {
          // Open/select product line so user can choose; do not add extra styling.
          setProductLineDropdownOpen(true);
          setTimeout(() => {
            productLineRef.current?.focus();
          }, 0);
          return;
        }

        // If product line exists but gross missing or invalid, focus gross input
        setTimeout(() => {
          grossInputRef.current?.focus({ cursor: "end" });
        }, 0);

        return;
      }

      // If valid, proceed to save
      saveEdit(record);
    }, 0);
  };

  const saveEdit = (record) => {
    if (record.state === "Cancel") {
      setEditingRowKey(null);
      setProductLineDropdownOpen(false);
      return;
    }

    if (!hasEditedRow) {
      setEditingRowKey(null);
      return;
    }

    const validationResult = validateMandatoryEditFields(record);
    if (!validationResult) {
      return;
    }

    const { productLineValue, grossValue } = validationResult;

    setTableData((prev) =>
      prev.map((row) =>
        row.key === record.key
          ? {
              ...row,
              productLine: productLineValue,
              grossWholesalePrice: grossValue,
            }
          : row
      )
    );

    dispatch(
      editSrStyleList(
        userNameMicrosoft,
        record.key,
        productLineValue,
        record.state ?? "",
        grossValue
      )
    );

    setHasEditedRow(false);
    setProductLineDropdownOpen(false);
    setEditingRowKey(null);
  };

  const revertGrossCheckoutValue = (record) => {
    setTableData((prev) =>
      prev.map((row) =>
        row.key === record.key
          ? {
              ...row,
              productLine: originalProductLine[record.key] ?? "",
              grossWholesalePrice: originalGrossWholesaleValue[record.key] ?? "",
            }
          : row
      )
    );
    setHasEditedRow(false);
    setEditingRowKey(null);
  };

  // -------------------- COLUMNS --------------------
  const columns = [
    {
      title: "Season",
      dataIndex: "season",
      render: (text, record) => (
        <span style={getDisabledStyle(record.state === "Cancel")}>
          {text}
        </span>
      ),
    },
    {
      title: "Style",
      dataIndex: "style",
      render: (text, record) => (
        <span style={getDisabledStyle(record.state === "Cancel")}>
          {text}
        </span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text, record) => (
        <span style={getDisabledStyle(record.state === "Cancel")}>
          {text}
        </span>
      ),
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
      render: (text, record) => (
        <span style={getDisabledStyle(record.state === "Cancel")}>
          {text}
        </span>
      ),
    },
    {
      title: "Size",
      dataIndex: "size",
      render: (text, record) => (
        <span style={getDisabledStyle(record.state === "Cancel")}>
          {text}
        </span>
      ),
    },
    {
      title: "Color",
      dataIndex: "color",
      render: (text, record) => (
        <span style={getDisabledStyle(record.state === "Cancel")}>
          {text}
        </span>
      ),
    },
    {
      title: "Product Line",
      render: (_, record) => {
        const isEditing = editingRowKey === record.key;
        const isDisabled = record.state === "Cancel";
        if (isEditing) {
          return (
            <div className="sr-edit-productline-wrapper">
            <Select
              style={{ width: 150 }}
              open={productLineDropdownOpen}
              autoFocus
              ref={productLineRef}
              disabled={isDisabled}
              value={record.productLine || undefined}
              options={
                (massFilterApiData?.productline || srList?.productline || srSeasonData?.productline)?.map((pl) => ({
                  label: pl,
                  value: pl,
                })) || []
              }
              onChange={(value) => {
                if (isDisabled) return;
                setHasEditedRow(true);
                setProductLineDropdownOpen(false);

                setTableData((prev) =>
                  prev.map((row) =>
                    row.key === record.key
                      ? { ...row, productLine: value ?? "" }
                      : row
                  )
                );

                setTimeout(() => {
                  grossInputRef.current?.focus({ cursor: "end" });
                }, 0);
              }}
              onBlur={() => handleEditorBlur(record)}
            />
            </div>
          );
        }

        return <span>{record.productLine || "-"}</span>;
      },
    },
    {
      title: "Gross Wholesale Price",
      dataIndex: "grossWholesalePrice",
      render: (_, record) => {
        const isEditing = editingRowKey === record.key;
        const isDisabled = record.state === "Cancel";
        if (isEditing) {
          return (
            <div className="sr-edit-gross-wrapper">
              <Input
                ref={grossInputRef}
                autoFocus
                style={{ width: 150 }}
                value={record.grossWholesalePrice ?? ""}
                disabled={isDisabled}
                onChange={(e) => {
                  if (isDisabled) return;
                  setHasEditedRow(true);

                  const sanitizedValue = sanitizeGrossValue(e.target.value);
                  setTableData((prev) =>
                    prev.map((row) =>
                      row.key === record.key
                        ? { ...row, grossWholesalePrice: sanitizedValue }
                        : row
                    )
                  );
                }}
                onPressEnter={() => saveEdit(record)}
                onBlur={() => handleEditorBlur(record)}
              />
            </div>
          );
        }

        const hasGrossValue =
          record.grossWholesalePrice !== null &&
          record.grossWholesalePrice !== undefined &&
          `${record.grossWholesalePrice}`.trim() !== "";

        return <span>{hasGrossValue ? `$${record.grossWholesalePrice}` : "-"}</span>;
      },
    },
    {
      title: "Packaging",
      dataIndex: "packagingStatus",
      render: (_, record) => {
        if (!record.packagingStatus) return <span>-</span>;

        const isDisabled = record.state === "Cancel";
        const badgeClass =
          record.packagingStatus === "Confirmed"
            ? "sr-packaging-badge-confirmed"
            : record.packagingStatus === "Not Started"
            ? "sr-packaging-badge-not-started"
            : "sr-packaging-badge-progress";
        const packagingChecks = [
          { label: "Packing Type Identified", value: record.packingTypeIdentified },
          {
            label: "Packaging Size Vendor Confirmed",
            value: record.packagingSizeVendorConfirmed,
          },
          {
            label: "Packaging Graphics Finalized",
            value: record.packagingGraphicsFinalized,
          },
        ];

        return (
          <Popover
            placement="bottom"
            trigger="hover"
            overlayClassName="sr-packaging-popover"
            title="Packaging Confirmation"
            content={
              <div className="sr-packaging-checks">
                {packagingChecks.map((check) => (
                  <div className="sr-packaging-check" key={check.label}>
                    <span className="sr-packaging-check-label">
                      {check.label}
                    </span>
                    {check.value ? (
                      <span className="sr-packaging-check-yes">
                        <CheckOutlined /> YES
                      </span>
                    ) : (
                      <span className="sr-packaging-check-no">NO</span>
                    )}
                  </div>
                ))}
              </div>
            }
          >
            <span
              className={`sr-packaging-badge ${badgeClass}`}
              style={{ opacity: isDisabled ? 0.5 : 1 }}
            >
              <span className="sr-packaging-dot" />
              {record.packagingStatus}
            </span>
          </Popover>
        );
      },
    },
    {
      title: "Status",
      render: (_, record) => {
        const isDisabled = record.state === "Cancel";

        return (
          <div className="sr-status-wrapper">
            <span
              className={
                isDisabled
                  ? "status-cancel"
                  : record.status === "Product Ready"
                  ? "status-active"
                  : record.status === "In Development"
                  ? "status-in-development"
                  : "status-active"
              }
            >
              {record.status}
            </span>

            <img
              src={EditIcon}
              className="edit-icon"
              alt="edit"
              style={getDisabledStyle(isDisabled)}
              onClick={() => {
                if (!isDisabled) {
                  setEditingRowKey(record.key);
                  setHasEditedRow(false);
                  setProductLineDropdownOpen(true);
                  setOriginalProductLine((prev) => ({
                    ...prev,
                    [record.key]: record.productLine
                  }));
                  setOriginalGrossWholesaleValue((prev) => ({
                    ...prev,
                    [record.key]: record.grossWholesalePrice ?? ""
                  }));
                }
              }}
            />

            <CopyOutlined
              className="action-icon"
              style={getDisabledStyle(isDisabled)}
              onClick={() => !isDisabled && handleDuplicate(record)}
            />

            <Switch
              size="small"
              checked={record.state?.toLowerCase() === "active"}
              onChange={(checked) =>
                handleStatusChange(checked, record)
              }
              checkedChildren="Active"
              unCheckedChildren="Cancel"
            />

            <div onClick={() => onLogsClick(record)} style={{cursor: "pointer"}}>
              <img height={15} width={15} src={Info} alt="info" />
            </div>
          </div>
        );
      },
    },
  ];

  const isNoLogs = !srLogs?.results?.length;
  // const searchUIValue = searchInput?.join(", ") || "";
  const removeFilter = (key) => {
    const newSearch = key === "searchFilter" ? [] : searchInput;
    const newVendor = key === "vendorFilter" ? "" : vendorFilter;
    const newColor = key === "colorFilter" ? "" : colorFilter;
    const newSize = key === "sizeFilter" ? "" : sizeFilter;

    if (key === "searchFilter") setSearchInput("");
    if (key === "vendorFilter") setVendorFilter(undefined);
    if (key === "colorFilter") setColorFilter(undefined);
    if (key === "sizeFilter") setSizeFilter(undefined);

    dispatch(
      massSrSearchFilter(
        newSearch,
        brand,
        newColor,
        newSize,
        newVendor,
        0,
        seasonFilter,
        1,
        100
      )
    );
  };
  const hasSearch =
    Array.isArray(searchInput)
      ? searchInput.length > 0
      : !!searchInput;

  useEffect(() => {
    if (!containerRef?.containerRef?.containerRef?.current) return;

    const scrollEl = containerRef?.containerRef?.containerRef?.current;
    console.log("scrollllllllll", scrollEl);
    const handleScroll = () => {
      const { scrollTop, clientHeight, scrollHeight } = scrollEl;

      const bottomReached =
        scrollTop + clientHeight >= scrollHeight - 10;

      if (!bottomReached || isChunkLoading) return;

      // ✅ Only reveal chunks within current page
      if (visibleCount < tableData.length) {
        setIsChunkLoading(true);

        setTimeout(() => {
          setVisibleCount(prev =>
            Math.min(prev + chunkSize, tableData.length)
          );
          setIsChunkLoading(false);
        }, 300);
      }
    };
    scrollEl.addEventListener("scroll", handleScroll);
    return () =>
      scrollEl.removeEventListener("scroll", handleScroll);

  }, [visibleCount, tableData.length, chunkSize, containerRef]);
  const onChange = (page) => {
    if (isChangingPageSizeRef.current) return;

    setCurrent(page);
    updateQueryParams(page, pageCount);

    // ✅ CALL API HERE
    if (massFilterApiData?.results?.length) {
      dispatch(
        massSrSearchFilter(
          searchInput,
          brand,
          colorFilter,
          sizeFilter,
          vendorFilter,
          0,
          seasonFilter,
          page,
          pageCount
        )
      );
    } else if (srSeasonData?.results?.length) {
      dispatch(
        massSrSearchFilter(
          searchInput,
          brand,
          colorFilter,
          sizeFilter,
          vendorFilter,
          0,
          seasonFilter,
          page,
          pageCount
        )
      );
    } else {
      dispatch(
        getSrInitialList(
          brand,
          "",
          "",
          0,
          "",
          "",
          page,
          pageCount
        )
      );
    }
  };
  return (
    <div className="sr-table">
      <div className="filtered-with-conatiner">
        <h3>Filtered With:</h3>
        <div className="filtered-list">

          {hasSearch && (
            <p onClick={() => removeFilter("searchFilter")}>
              <CloseOutlined />
              <span className="filtered-data">
                {Array.isArray(searchInput) && searchInput.length > 0
                  ? searchInput.join(", ")
                  : searchInput}
              </span>
            </p>
          )}

          {vendorFilter && (
            <p onClick={() => removeFilter("vendorFilter")}>
              <CloseOutlined />
              <span className="filtered-data 1">{vendorFilter}</span>
            </p>
          )}
          {colorFilter && (
            <p onClick={() => removeFilter("colorFilter")}>
              <CloseOutlined />
              <span className="filtered-data">{colorFilter}</span>
            </p>
          )}
          {sizeFilter && (
            <p onClick={() => removeFilter("sizeFilter")}>
              <CloseOutlined />
              <span className="filtered-data">{sizeFilter}</span>
            </p>
          )}
        </div>
      </div>

      {loading ? (<Loader />) : (

        <>
          <Table
            rowKey="key"
            columns={columns}
            dataSource={tableData.slice(0, visibleCount)}
            pagination={false}
            rowSelection={rowSelection}
          />
          {isChunkLoading && (
            <BeatLoader
              color={"#0C3D5E"}
              loading={isChunkLoading}
              cssOverride={{
                margin: "30px auto",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                borderColor: "#0C3D5E",
              }}
              size={10}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          )}
          <Pagination
            current={current}
            total={srList?.count || 0}
            pageSize={pageCount}
            showSizeChanger={false}
            onChange={onChange}
            style={{ textAlign: "right", marginTop: "20px" }}
          />
        </>
      )}
      <Modal
        className="sr-logs-modal-container"
        width={1000}
        title={
          <div className="srt-logs-header">
            <div className="logs-sent-header-details">
              <span>
                SR LOGS : <b>Product Ready</b>
              </span>
              {
                selectedRecord && (
                  <>
                    {/* <span>{selectedRecord?.season}</span> */}
                    <span>Season: {selectedRecord?.season}</span>
                    <span>Style: {selectedRecord?.style}</span>
                    {/* <span>{selectedRecord?.factory}</span> */}
                    <span>Vendor: {selectedRecord?.vendor}</span>
                    <span>Size: {selectedRecord?.size}</span>
                    <span>Color: {selectedRecord?.color}</span>
                  </>
                )
              }
            </div>
          </div>
        }
        open={isLogsModalOpen}
        onCancel={() => setisLogsModalOpen(false)}
        footer={null}
        centered
        destroyOnClose
      >
        {SrLogsLoading ? (
          <BeatLoader
            color={"#0C3D5E"}
            loading={SrLogsLoading}
            size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
            cssOverride={{
              margin: "30px auto",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              borderColor: "#0C3D5E",
            }}
          />
        ) : <>
          {srLogs?.results?.length == 0 ||
            srLogs?.results?.length == 0 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>
                <b>No logs yet</b>
              </p>
            </div>
          ) : (
            srLogs?.results?.map((log) => (
              <div className="sr-logs-container" key={log?.log_id}>
                <p className="log-number-container">{log?.log_id}</p>
                <div className="sr-logs">
                  <div>
                    <p>
                      {log?.timestamp}
                      <span>
                        - <b>{log?.updated_by}</b>
                      </span>
                    </p>
                  </div>
                  <div className="logs-btn-container">

                    <button
                      className={
                        log?.previous_value === "Active"
                          ? "logs-approved"
                          : log?.previous_value === "Cancel"
                            ? "logs-dropped"
                            : "logs-default"
                      }
                    >
                      {log?.previous_value !== null &&
                        log?.previous_value !== "" &&
                        log?.previous_value !== "undefined" &&
                        log?.previous_value !== "null"
                        ? <p>
                          {log?.previous_value ? log?.previous_value : "NA"}
                        </p>
                        : "-"}
                    </button>
                    <p>-------&gt;</p>
                    <button
                      className={
                        log?.action === "DUPLICATE_RECORD"
                          ? "logs-duplicate"
                          : log?.new_value === "Active"
                            ? "logs-approved"
                            : log?.new_value === "Cancel"
                              ? "logs-dropped"
                              : "logs-default"
                      }
                    >
                      {log?.action === "DUPLICATE_RECORD"
                        ? <p>{log?.new_value}</p>
                        : log?.new_value && !["null", "undefined", "", "null"].includes(log?.new_value)
                          ? <p>{log?.new_value}</p>
                          : "-"
                      }
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </>}
      </Modal>
      <Modal
        title=""
        open={popupOpen}
        onCancel={() => setIsPopupOpen(false)}
        footer={null}
        width={600}
        className="setup_modal"
      >
        {popupMessage}
      </Modal>
    </div>
  );
};

export default SrTable;